import { Voucher, createBlockVoucherMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockVoucherModel = ConfirmModalModel<Voucher, number, Voucher>;

export const createBlockVoucherModel = (): BlockVoucherModel => {
	const blockVoucherMutation = createBlockVoucherMutation();

	const model = createConfirmModalModel<Voucher, number, Voucher>({
		modalData: declareModalData<Voucher>(),
		mapModalData: ({ id }) => id,
		mutation: blockVoucherMutation,
		successMessageKey: 'block-voucher.success',
	});

	return model;
};
